import Headroom from 'headroom.js';

const header = document.querySelector('.header');
const { body } = document;

// Headroom JS
const myElement = header;
const headroom = new Headroom(myElement, {
  offset: 80,
  tolerance: {
    up: 3,
    down: 0,
  },
  classes: {
    initial: 'header--initial',
    pinned: 'header--pinned',
    unpinned: 'header--unpinned',
    top: 'header--top',
    notTop: 'header--not-top',
    bottom: 'header--bottom',
    notBottom: 'header--not-bottom',
  },
});

document.querySelectorAll('.header').forEach(() => {
  headroom.init();
});

/**
 * Toggle header classes
 */

if (header) {
  const bodyMenuOpen = 'body--mobile-menu-open';
  const headerMenuOpen = 'header--mobile-menu-open';
  const mobileMenu = document.querySelector('.header__nav');
  const buttonOpenMenu = document.querySelector('.header__toggle__button');
  const buttonCloseMenu = document.querySelector('.header__nav__toggle__button');

  // Open mobile menu
  const openMenu = (event) => {
    body.classList.add(bodyMenuOpen);
    header.classList.add(headerMenuOpen);
    buttonOpenMenu.setAttribute('aria-expanded', body.classList.contains(bodyMenuOpen));
    event.stopPropagation();
    return false;
  };
  buttonOpenMenu.addEventListener('click', openMenu);

  // Close mobile menu
  const closeMenu = () => {
    body.classList.remove(bodyMenuOpen);
    header.classList.remove(headerMenuOpen);
    buttonCloseMenu.removeAttribute('aria-expanded', body.classList.contains(bodyMenuOpen));
    const level1Items = document.querySelectorAll('.header__nav__li-level1');
    level1Items.forEach(item => item.classList.remove('header__nav__li-level1--expanded'));
  };
  buttonCloseMenu.addEventListener('click', closeMenu);

  // Click outside
  const clickOutsideMobileMenu = (event) => {
    const isClickInside = mobileMenu.contains(event.target);
    if (!isClickInside) {
      closeMenu();
    }
  };
  document.addEventListener('click', clickOutsideMobileMenu);
}

// Toggle submenu (on mobile)
document.querySelectorAll('.header__nav__li-level1').forEach((wrap) => {
  const buttonsLevel1 = wrap.querySelectorAll('button.header__nav__li-level1__item');
  const toggleSubmenu = () => {
    if (wrap.classList.contains('header__nav__li-level1--expanded')) {
      wrap.classList.remove('header__nav__li-level1--expanded');
    } else {
      wrap.classList.add('header__nav__li-level1--expanded');
    }
  };
  buttonsLevel1.forEach(button => button.addEventListener('click', toggleSubmenu));
});
